import React from 'react'

export const Info = () => <path d='M12,23C5.9,23,1,18.1,1,12S5.9,1,12,1s11,4.9,11,11S18.1,23,12,23z M12,3c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S17,3,12,3z M13,7c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S13,6.4,13,7z M11,10.4c0-0.6,0.4-1,1-1s1,0.4,1,1V17c0,0.6-0.4,1-1,1s-1-0.4-1-1V10.4z' />
